import {ChangeDetectionStrategy, Component, Input, OnChanges, OnInit} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {ProductPricing, StandardName} from "../../../../../store/state/order.state";
import {EndpointsProvider} from "../../../../../umbrella-common/endpoints/endpoint-provider.service";
import {map} from "rxjs/operators";
import {Observable} from "rxjs";

@Component({
    selector: 'pre-audit-checkbox',
    templateUrl: './pre-audit-checkbox.template.html',
    styleUrls: ['./pre-audit-checkbox.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PreAuditCheckboxComponent implements OnInit, OnChanges {

	@Input() standardName: StandardName;
	@Input() form: FormGroup;
	@Input() pricing: ProductPricing;
	@Input() correlationId: string;
	@Input() clientLogged: boolean;
	@Input() clientCountry: string;
	@Input() preAudit: boolean = false;

	preAuditDateInfoVisible: boolean
	priceConfigChanged$: Observable<boolean>;
	preAuditChecked: boolean;

	constructor(private endpoints: EndpointsProvider) {
	}

	ngOnInit(): void {
		this.checkIfPriceChanged();
    }

	ngOnChanges(): void {
        if (this.preAudit && this.clientLogged) {
			this.preAuditChecked = this.preAudit;
		}
    }

	togglePreAuditInfo() {
		this.preAuditDateInfoVisible = !this.preAuditDateInfoVisible;
	}

	get preAuditCost(): number {
		let preAuditTotalMandays = this.preAuditMandays;
		return this.pricing.pricingAdjustments.dailyRate * preAuditTotalMandays || this.pricing.dailyRate * preAuditTotalMandays;
	}

	get preAuditMandays() {
		let preAuditTotalMandays = 1;
		if ("NL" === this.clientCountry) {
			preAuditTotalMandays = 1.25;
		}
		return preAuditTotalMandays;
	}

	get showPricing(): boolean {
		return this.pricing.dailyRate !== null && this.pricing.dailyRate !== 0;
	}

	onChange() {
		this.checkIfPriceChanged();
		this.preAuditChecked = !this.preAuditChecked;
	}

	checkIfPriceChanged() {
		this.priceConfigChanged$ = this.endpoints.common.checkPricingConfigChanged(this.correlationId).pipe(map(configChanged => configChanged));
	}
}
